import { useTranslation } from 'react-i18next';

import { Button } from '@ctct/ui-react';

import { useDiscountCodeContext } from '../DiscountCodeContext';

const DiscountCodeShowInput = () => {
  const { t } = useTranslation();
  const { showInput } = useDiscountCodeContext();

  return (
    <Button
      className="discount-code-container__open-button"
      text={t('order_summary.discount-code.i-have-discount-code')}
      shape="pill"
      kind="link"
      onClick={showInput}
    />
  );
};

export default DiscountCodeShowInput;
